import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import TabsCustom from "src/components/TabsCustom"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import { ToolBarStyle } from "../../HumanResource/Work/Task/styled"
import SvgIcon from "src/components/SvgIcon"
import { Input, Select, DatePicker, message } from "antd"
import OrderService from "src/services/OrderService"
import { InputSearchStyle } from "../Setting/common/styled"

import ModalCreateOrder from "./Modal/ModalCreateOrder"
import ListOrder from "./component/ListOrder"
import FilterOrder from "./component/FilterOrder"
import STORAGE, { getStorage } from "src/lib/storage"

const Order = props => {
  const [disableBtn, setDisableBtn] = useState(false)
  const [tab, setTab] = useState("1")
  const [searchTerm, setSearchTerm] = useState("")
  const [openModalCreate, setOpenModalCreate] = useState(false)
  const [activeKey, setActiveKey] = useState("all")
  const [refresh, setRefresh] = useState(false)
  const [filter, setFilter] = useState({})
  const [tabStatus, setTabStatus] = useState("order")
  const [excelKeyword, setExcelKeyword] = useState("")

  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: "order",
    },
    // pending: {
    //   type: "pending",
    //   name: "Chờ duyệt",
    //   status: "0",
    // },
    success: {
      type: "success",
      name: "Đã duyệt",
      status: "1",
    },
    received: {
      type: "received",
      name: "Đã tiếp nhận",
      status: "2",
    },
    order_done: {
      type: "order_done",
      name: "Hoàn thành mua",
      status: "3",
    },
    export: {
      type: "export",
      name: "Đã xuất kho",
      status: "4",
    },
    reject: {
      type: "reject",
      name: "Đã hủy",
      status: "5",
    },
  }

  const items = Object.keys(Tabs).map(key => ({
    key,
    label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  }))
  const handleChangeTab = key => {
    setActiveKey(key)
    setTabStatus(Tabs[key].status)
  }
  const location = useLocation()
  const { type, statusOrder } = location.state || {}

  useEffect(() => {
    // console.log(type, statusOrder, "locate")
    if (statusOrder) {
      const foundKey = Object.keys(Tabs).find(
        key => Tabs[key].type === statusOrder,
      )
      if (foundKey) {
        setActiveKey(foundKey)
        setTabStatus(statusOrder)
      }
    }
  }, [statusOrder])

  const handleExportExcel = async () => {
    try {
      const response = await OrderService.exportData({
        // status: filter.status ?? null,
        // sim_type: filter.sim_type ?? null,
        // supplier_id: filter.supplier_id ?? null,
        // carrier_id: filter.carrier_id ?? null,
        // package_id: filter.package_id ?? null,
        // type: filter.type ?? null,
        ...filter,
        status: Tabs[activeKey]?.status,
        keyword: excelKeyword,
        order_export_status : 1
      })

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "Danh_sach_don_hang.xlsx")
        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }

  const [shownError, setShownError] = useState(false)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const hasPermission = permissions.includes("order")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }

  return (
    <div>
      <WrapperStyle>
        <ToolBarStyle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 4,
              marginBottom: 20,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#005F90",
                margin: 0,
              }}
            >
              ĐƠN HÀNG
            </h3>
          </div>
          <div className="right-side">
            {permissions.includes("order.create") ? (
              <Button
                btnType="primary1"
                onClick={() => setOpenModalCreate(true)}
                size="small"
                disabled={disableBtn}
              >
                Tạo đơn hàng
              </Button>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("order.export") ? (
              <Button btnType="primary1" onClick={handleExportExcel}>
                Xuất Excel
              </Button>
            ) : (
              <React.Fragment />
            )}
          </div>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <StyleTabsCustom>
              <TabsCustom
                onChange={handleChangeTab}
                // activeKey={activeKey}
                // items={items}
                // defaultActiveKey="all"
                // type="card"
                // destroyInactiveTabPane={true}
                // scroll={{ x: true }}
                activeKey={activeKey}
                items={items}
                defaultActiveKey="all"
                type="card"
              />
            </StyleTabsCustom>
            <ListOrder
              // type={Tabs[key].type}
              scroll={{ x: true }}
              tabStatus={tabStatus}
              setParentFilter={setFilter}
              filter={filter}
              refresh={refresh}
              setRefresh={setRefresh}
              permissions={permissions}
              setExcelKeyword ={setExcelKeyword}
            />
          </div>
        </ToolBarStyle>
      </WrapperStyle>
      {openModalCreate && (
        <ModalCreateOrder
          open={openModalCreate}
          onCancel={() => setOpenModalCreate(false)}
          onOk={() => {
            setOpenModalCreate(false)
          }}
          refresh={setRefresh}
        />
      )}
    </div>
  )
}

export default Order
